import { IconBaseType } from "@/v2-components/core/icon/type";
import { cn } from "@/libs/utils";

export default function CartFilledIcon({ className }: IconBaseType) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
    >
      <path
        d="M16.55 13C17.77 13 18.29 11.99 18.3 11.97L21.85 5.53C22.08 5.08 22.03 4.69 21.84 4.42C21.66 4.16 21.33 4 21 4C20.99 4 6.21 4 6.21 4L5.54 2.57C5.38 2.22 5.02 2 4.64 2H3C2.45 2 2 2.45 2 3C2 3.55 2.45 4 3 4H4L7.6 11.59L6.25 14.03C5.52 15.37 6.48 17 8 17H19C19.55 17 20 16.55 20 16C20 15.45 19.55 15 19 15H8L9.1 13H16.55Z"
        fill="currentColor"
      />
      <path
        d="M10 20C10 21.1046 9.10457 22 8 22C6.89543 22 6 21.1046 6 20C6 18.8954 6.89543 18 8 18C9.10457 18 10 18.8954 10 20Z"
        fill="currentColor"
      />
      <path
        d="M20 20C20 21.1046 19.1046 22 18 22C16.8954 22 16 21.1046 16 20C16 18.8954 16.8954 18 18 18C19.1046 18 20 18.8954 20 20Z"
        fill="currentColor"
      />
    </svg>
  );
}
